<template>
	<main class="main-wrapper flex-grow-1 bg-documentGray forceHeight68">
		<div class="d-flex align-items-center bg-white">
			<div
				class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
				{{ $t("704") }}
			</div>
			<div class="mgr-24 right-button">
				<button class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" tabindex="0" type="button"
					@click="goBackToSurvey" @keypress="goBackToSurvey">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-color-iconActive font-r">{{
						$t("3312")
					}}</span>
				</button>
			</div>
		</div>
		<div class="divider"></div>

		<div v-if="surveyData" class="container container--narrow pdt-50">
			<div class="mgt-50">
				<div class="mdc-card pdt-26 pdb-36 pdl-36 pdr-36">
					<div class="d-flex">
						<div>
							<img alt="" class="icon62" src="../../images/survey_guid-icon.svg" />
						</div>
						<div class="pdl-22 flex-grow-1 d-flex flex-column">
							<div v-if="surveyData.name" class="t-headline11 font-m t-line-h-36 l-spacing72">
								{{ surveyData.name }}
							</div>
							<div v-if="surveyData.summary"
								class="mgt-16 t-body6 t-color-bodyGrayA font-r l-spacing45 t-line-h-22">
								{{ surveyData.summary }}
							</div>
							<div class="divider mgt-32 mgb-32 h-2"></div>
							<div class="d-grid-2-16">
								<div class="pdl-13 position-relative bullet-list d-flex align-items-center">
									<span class="t-body1 t-color-bodyGrayA font-r pdr-8">{{
										$t("705")
									}}</span>
									<span class="t-body1 font-b pdr-8">{{
										surveyData.questionCount
									}}</span>
								</div>
								<div class="pdl-13 position-relative bullet-list d-flex align-items-center">
									<span class="t-body1 t-color-bodyGrayA font-r pdr-8">{{
										$t("706")
									}}</span>
									<span class="t-body1 font-b pdr-8">{{ finalTime }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="mgt-50">
				<button v-if="surveyData.progression.value === 'RESPONDENT' ||
					surveyData.progression.value === 'NONRESPONSE'
					" class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 w-full" tabindex="0"
					@click="moveSurveyTakeWithLearnId()" @keypress="moveSurveyTakeWithLearnId()">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{ $t("707") }}</span>
				</button>
				<button v-if="surveyData.progression.value === 'SUBMITTED'"
					class="mdc-button mdc-button--raised bg-white t-color-secondaryBtnText b-radius4 w-full" tabindex="0"
					@click="moveSurveyResult()" @keypress="moveSurveyResult()">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{ $t("708") }}</span>
				</button>
				<button v-if="surveyData.progression.value === 'WAITING'" class="mdc-button bg-disableBtn w-full disabled"
					disabled>
					<span class="mdc-button__label t-body2 font-r t-color-disableBtnText font-r">{{ $t("709") }}</span>
				</button>
			</div>
		</div>
	</main>
</template>

<script>
/**
 * 설문 인트로 컴포넌트(survey intro main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { surveyMixin } from "@/mixins/survey.js";
import { MDCRipple } from "@material/ripple";

export default {
	name: "surveyIntro",

	mixins: [surveyMixin],

	data() {
		return {
			surveyData: null,
			surveyMinit: 0,
			surveySec: 0,
			finalTime: 0,
		};
	},

	created() {
		this.fatchData();
	},

	mounted() {
		this.setMaterialUi();
	},

	methods: {
		setMaterialUi() {
			const buttonRipple = [].map.call(
				document.querySelectorAll(".mdc-button"),
				function (el) {
					let button = new MDCRipple.attachTo(el);
					return button;
				}
			);
		},

		// get survey respondent intro data
		fatchData() {
			let params = {
				respondentId: this.$route.params.respondentId,
			};
			surveyApi.surveyRespondentIntro(params).then((response) => {
				this.surveyData = response.data.data;
				if (this.surveyData.useTimeout) {
					this.surveyMinit = Math.floor(parseInt(this.surveyData.timeout) / 60);
					this.finalTime =
						this.surveyData.timeout.toFixed() +
						"m" +
						" " +
						this.surveySec.toFixed() +
						"sec";
				} else {
					this.finalTime = this.$t("3328");
				}
			});
		},

		moveSurveyResult() {
			let params = {
				respondentId: this.$route.params.respondentId,
			};
			this.$router.push({
				name: "IndependentSurveyResult",
				params: params,
				query: this.$route.query,
			});
		},

		moveSurveyTakeWithLearnId() {
			this.$router.push({
				name: "IndependentSurveyTake",
				query: {
					status: this.$route.query.status,
					learnId: this.$route.query.learnId,
					distributionType: this.$route.query.distributionType,
					isMicro: this.$route.query.isMicro,
					type: this.$route.query.type,
				},
			});
		},
	},
};
</script>